module.exports = __webpack_public_path__ + "static/Sonyax51-9500f34beaac466f8d4de9cc8eb06381.png";